import {useState, useEffect} from "react";
import './App.scss';
import { ThemeProvider } from '@material-ui/core';
import SignIn from "./components/InvoiageSignIn";
import SignUp from "./components/InvoiageSignUp";
import InvoiageNavigation from "./components/InvoiageNavigation";
import InvoiageCopyright from "./components/InvoiageCopyright";
import { invoiageTheme } from "./themes/eptheme";
import Confetti from "./utils/Confetti"
import { Route, BrowserRouter, useHistory, Switch } from "react-router-dom";

import UserContext from "./contexts/UserContext";
import PrivateRoute from "./utils/PrivateRoute";
import CheckToken from "./components/CheckToken";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import ConfirmEmail from "./components/ConfirmEmail";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import TextractContainer from "./components/textract/TextractContainer";
import { seo } from "./components/helpers/seo";

import InvoiageWidgets from "./components/widgets/InvoiageWidgets";
import AuthorizationIndex from "./components/textract/authorizations/AuthorizationIndex";
import Authorization from "./components/textract/authorizations/Authorization";

function App() {
  const [user, setUser] = useState({loggedIn: !!localStorage.getItem("jwt")})
  const [properties, setProperties] = useState([])
  const [activeTheme, setActiveTheme] = useState(invoiageTheme)
  const [selectedTemplate, setSelectedTemplate] = useState({name: "", subject: "", body: ""})
  const [widgetOptions, setWidgetOptions] = useState({})
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const darkMode = false;
  useEffect(_ => {
    setActiveTheme(invoiageTheme);
    seo({
      title: "Invoiage"
    })
  }
  , [user]) // TODO: Make this dynamic on embeds
  return (
    <ThemeProvider theme={activeTheme}>
      <UserContext.Provider value={{widgetOptions, setWidgetOptions, activeTheme, setActiveTheme, user, setUser, properties, setProperties, selectedTemplate, setSelectedTemplate }}>
        <div key={`${activeTheme.palette.mode}-mode`} className={`${activeTheme.palette.mode}-mode`}>
          <Confetti />
          <BrowserRouter>
            <CheckToken />
            <Switch>
              <Route path="/credentials-transfer">
                <InvoiageWidgets />
              </Route>
              <Route path="/file-upload">
                <InvoiageWidgets />
              </Route>
              <Route>
                <div className="App">
                  <InvoiageNavigation />
                  
                  <PrivateRoute path="/documents" component={TextractContainer} />
                  <Route exact path="/authorizations" component={AuthorizationIndex} />
                  <Route exact path="/authorizations/:id" component={Authorization} />
                  
                  <Route exact path="/confirm" component={ConfirmEmail} />
                  <Route path="/login" component={SignIn} />
                  <Route path="/signup" component={SignUp} />
                  <Route exact path="/" component={SignIn} />
                  <InvoiageCopyright />
                </div>
              </Route>
            </Switch>
          </BrowserRouter>
        </div>
      </UserContext.Provider>
    </ThemeProvider>
  );
}

export default App;
